import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-rail",
  "aria-label": "Main"
}
const _hoisted_2 = { class: "app-rail__group" }
const _hoisted_3 = {
  key: 0,
  class: "icon-btn-dot"
}
const _hoisted_4 = { class: "app-rail__foot" }
const _hoisted_5 = ["aria-label", "data-tooltip"]
const _hoisted_6 = {
  key: 1,
  class: "sidenav app-sidenav",
  "aria-label": "Main"
}
const _hoisted_7 = { class: "sidenav-group" }
const _hoisted_8 = {
  key: 0,
  class: "sidenav-count"
}
const _hoisted_9 = {
  key: 0,
  class: "sidenav-group"
}
const _hoisted_10 = { class: "sidenav-footer" }
const _hoisted_11 = { class: "avatar" }
const _hoisted_12 = { class: "sidenav-footer-text" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "sidenav-footer-meta" }

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AuthStore from '@/store/AuthStore'
import { RootRoute, RootRouter } from '@/router'
import AtlasIcon from '@/component/ui/AtlasIcon.vue'
import { IconName } from '@/component/ui/icons'
import { initials } from '@/lib/format'

interface NavItem {
  to: string
  label: string
  icon: IconName
  count?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSidebar',
  props: {
    runningJobs: {},
    collapsed: { type: Boolean }
  },
  emits: ["navigate"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const route = useRoute()

const email = computed(() => AuthStore.module.email ?? '')
const isAdmin = computed(() => AuthStore.module.isAdmin)
const roleLabel = computed(() => {
  const role = AuthStore.module.role ?? ''
  return role.charAt(0).toUpperCase() + role.slice(1)
})

const workspaceItems = computed(() => {
  const items: NavItem[] = [{ to: '/', label: 'Data', icon: 'chart-column' }]
  if (AuthStore.module.canSeeJobs) {
    items.push({
      to: '/jobs',
      label: 'Jobs',
      icon: 'clock',
      count: props.runningJobs > 0 ? `${props.runningJobs} running` : undefined,
    })
  }
  items.push({ to: '/fb-api-stats', label: 'FB API stats', icon: 'activity' })
  return items
})

// Flat list for the rail: workspace items plus Users for admins.
const navItems = computed(() => {
  const items = workspaceItems.value.map(i => ({
    ...i,
    railLabel: i.count ? `${i.label} · ${i.count}` : i.label,
  }))
  if (isAdmin.value) items.push({ to: '/users', label: 'Users', icon: 'users', railLabel: 'Users' })
  return items
})

function isActive(to: string): boolean {
  return route.path === to
}

function logout() {
  AuthStore.module.logout()
  RootRouter.push(RootRoute.login('/'))
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (__props.collapsed)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "app-rail__brand",
          "aria-label": "Marketing — Eidolon analytics",
          "data-tooltip": "Marketing"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createElementVNode("span", { class: "app-brand-mark" }, "M", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navItems.value, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.to,
              to: item.to,
              class: "app-rail__item",
              "aria-current": isActive(item.to) ? 'page' : undefined,
              "aria-label": item.railLabel,
              "data-tooltip": item.railLabel,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('navigate')))
            }, {
              default: _withCtx(() => [
                _createVNode(AtlasIcon, {
                  name: item.icon
                }, null, 8, ["name"]),
                (item.count)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to", "aria-current", "aria-label", "data-tooltip"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "app-rail__item",
            type: "button",
            "aria-label": "Sign out",
            "data-tooltip": "Sign out",
            onClick: logout
          }, [
            _createVNode(AtlasIcon, { name: "log-out" })
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "app-rail__divider" }, null, -1)),
          _createElementVNode("span", {
            class: "avatar avatar--sm app-rail__avatar",
            "aria-label": `${email.value} · ${roleLabel.value}`,
            "data-tooltip": `${email.value} · ${roleLabel.value}`
          }, _toDisplayString(_unref(initials)(email.value)), 9, _hoisted_5)
        ])
      ]))
    : (_openBlock(), _createElementBlock("nav", _hoisted_6, [
        _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"app-brand\" data-v-44e59fe9><span class=\"app-brand-mark\" data-v-44e59fe9>M</span><span class=\"app-brand-text\" data-v-44e59fe9><span class=\"app-brand-name\" data-v-44e59fe9>Marketing</span><span class=\"app-brand-sub\" data-v-44e59fe9>Eidolon analytics</span></span></div>", 1)),
        _createElementVNode("div", _hoisted_7, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "sidenav-label" }, "Workspace", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workspaceItems.value, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.to,
              to: item.to,
              class: "sidenav-item",
              "aria-current": isActive(item.to) ? 'page' : undefined,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('navigate')))
            }, {
              default: _withCtx(() => [
                _createVNode(AtlasIcon, {
                  class: "sidenav-icon",
                  name: item.icon
                }, null, 8, ["name"]),
                _createElementVNode("span", null, _toDisplayString(item.label), 1),
                (item.count)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.count), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to", "aria-current"]))
          }), 128))
        ]),
        (isAdmin.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "sidenav-label" }, "Admin", -1)),
              _createVNode(_component_router_link, {
                to: "/users",
                class: "sidenav-item",
                "aria-current": isActive('/users') ? 'page' : undefined,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('navigate')))
              }, {
                default: _withCtx(() => [
                  _createVNode(AtlasIcon, {
                    class: "sidenav-icon",
                    name: "users"
                  }),
                  _cache[6] || (_cache[6] = _createElementVNode("span", null, "Users", -1))
                ]),
                _: 1
              }, 8, ["aria-current"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(initials)(email.value)), 1),
          _createElementVNode("span", _hoisted_12, [
            _createElementVNode("span", {
              class: "sidenav-footer-name app-footer-email",
              title: email.value
            }, _toDisplayString(email.value), 9, _hoisted_13),
            _createElementVNode("span", _hoisted_14, _toDisplayString(roleLabel.value), 1)
          ]),
          _createElementVNode("button", {
            class: "icon-btn app-logout",
            type: "button",
            title: "Sign out",
            "aria-label": "Sign out",
            onClick: logout
          }, [
            _createVNode(AtlasIcon, { name: "log-out" })
          ])
        ])
      ]))
}
}

})